import React from "react";
import $ from "jquery";
import SignupPanel from "./signupPanel";
import { extractErrorResponse } from "../../utils/utils";
import isEmail from "validator/lib/isEmail";
import { FormattedMessage } from "react-intl";

class SignupContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            panelTitleId: "signup.sigupPage.panelTitle",
            signupSuccess: false,
            email: "",
            emailExist: false,
            token: "",
            password: "",
            isLoading: false,
            statusMessages: [],
        };
        this.signupFormSubmit = this.signupFormSubmit.bind(this);
        this.handleTextFieldChange = this.handleTextFieldChange.bind(this);
        this.handleEmailResend = this.handleEmailResend.bind(this);
    }
    signupFormSubmit(event) {
        event.preventDefault();

        if (!isEmail(this.state.email)) {
            //if the email is invalid, set the form error messages and don't make ajax call
            this.setState({
                statusMessages: [
                    {
                        type: "error",
                        reason: "signup.email.invalid",
                    },
                ],
            });
        } else {
            // only make AJAX call if the mail is valid
            let self = this;
            let data = {
                email: this.state.email,
                password: this.state.password,
            };

            $.ajax({
                beforeSend: function(xhr) {
                    xhr.setRequestHeader(csrfHeaderName, csrfToken);
                    self.setState({
                        isLoading: true,
                    });
                },
                url: "/signup",
                type: "POST",
                contentType: "application/json",
                data: JSON.stringify(data),
                success: function(response) {
                    self.setState({
                        signupSuccess: true,
                        email: response.email,
                        token: response.token,
                        panelTitleId: "signup.signupSuccessPage.panelTitle",
                        statusMessages: [],
                    });
                },
                error: function(response) {
                    switch (response.status) {
                        case 400:
                            self.setState({
                                statusMessages: response.responseJSON,
                            });
                            break;
                        //if email account already exsist
                        case 409:
                            self.setState({
                                emailExist: true,
                            });
                            break;
                        default:
                            self.setState({
                                statusMessages: [
                                    {
                                        type: "error",
                                        reason: extractErrorResponse(response),
                                    },
                                ],
                            });
                    }
                },
                complete: function() {
                    self.setState({
                        isLoading: false,
                    });
                },
            });
        }
    }

    handleEmailResend(event) {
        event.preventDefault();
        let self = this;

        $.ajax({
            beforeSend: function(xhr) {
                xhr.setRequestHeader(csrfHeaderName, csrfToken);
                self.setState({
                    isLoading: true,
                });
            },
            url: "/signup/resend",
            data: {
                email: self.state.email,
                token: self.state.token,
            },
            type: "GET",
            success: function() {
                self.setState({
                    statusMessages: [
                        {
                            type: "success",
                            reason: "signup.resend.success",
                        },
                    ],
                });
            },
            error: function(response) {
                self.setState({
                    statusMessages: [
                        {
                            type: "error",
                            reason: extractErrorResponse(response),
                        },
                    ],
                });
            },
            complete: function() {
                self.setState({
                    isLoading: false,
                });
            },
        });
    }

    handleTextFieldChange(e) {
        this.setState({
            [e.target.name]: e.target.value,
        });
        if (e.target.name == "email") {
            this.setState({
                emailExist: false,
            });
        }
    }

    render() {
        return (
            <div>
                <SignupPanel
                    password={this.state.password}
                    email={this.state.email}
                    domain={this.props.domain}
                    emailExist={this.state.emailExist}
                    panelTitleId={this.state.panelTitleId}
                    isLoading={this.state.isLoading}
                    signupSuccess={this.state.signupSuccess}
                    handleEmailResend={this.handleEmailResend}
                    signupFormSubmit={this.signupFormSubmit}
                    handleTextFieldChange={this.handleTextFieldChange}
                    statusMessages={this.state.statusMessages}
                />
            </div>
        );
    }
}

export default SignupContainer;
